import { createAction } from "redux-actions";
import {
  BANK_ACCOUNT,
  FS_CREATE_ITEMS,
  FS_DELETE_ITEMS,
  FS_UPDATE_ITEMS,
} from "../common";

export const addBankAccountsRecords = createAction(
  BANK_ACCOUNT + FS_CREATE_ITEMS
);
export const updateBankAccountsRecords = createAction(
  BANK_ACCOUNT + FS_UPDATE_ITEMS
);
export const deleteBankAccountsRecords = createAction(
  BANK_ACCOUNT + FS_DELETE_ITEMS
);
